import {
    RESET_REVIEWING_REPORT,
    VIEW_PARKED_VISIT_ERROR,
    VIEW_PARKED_VISIT_START,
    VIEW_PARKED_VISIT_SUCCESS,
    VIEW_SUBMITTED_FOR_VERIFICATION_VISIT_ERROR, VIEW_SUBMITTED_FOR_VERIFICATION_VISIT_START,
    VIEW_SUBMITTED_FOR_VERIFICATION_VISIT_SUCCESS,
    VIEW_SUBMITTED_TO_TYPIST_VISIT_ERROR,
    VIEW_SUBMITTED_TO_TYPIST_VISIT_START,
    VIEW_SUBMITTED_TO_TYPIST_VISIT_SUCCESS
} from '../../actions/groupadmin/reportViewerAction';

const INIT_STATE = {
    error: "",
    loading: false,
    submitting: false,
    message: '',
    searchParams: null,
    found: false,
    report: null,
    unlocking: false,
    priorReportsLoaded: false,
    patientHistoryReports: [],
    audioUpload: {
        uploading: false,
        percentCompleted: 0,
        error: false,
    }
};

const reportViewerReducer = (state = INIT_STATE, action) => {
    let newState;
    let newReport;
    let index;
    switch (action.type) {

        case VIEW_SUBMITTED_FOR_VERIFICATION_VISIT_START:
        case VIEW_PARKED_VISIT_START:
        case VIEW_SUBMITTED_TO_TYPIST_VISIT_START:
            {
                return { ...state, error: '', message: '', found: false, loading: true };
            }

        case VIEW_SUBMITTED_FOR_VERIFICATION_VISIT_SUCCESS:
        case VIEW_PARKED_VISIT_SUCCESS:
        case VIEW_SUBMITTED_TO_TYPIST_VISIT_SUCCESS:
            {
                return { ...state, error: '', message: '', found: true, loading: false, report: { ...action.report } };
            }

        case VIEW_SUBMITTED_FOR_VERIFICATION_VISIT_ERROR:
        case VIEW_PARKED_VISIT_ERROR:
        case VIEW_SUBMITTED_TO_TYPIST_VISIT_ERROR:
            {
                return { ...state, error: '', message: '', found: false, loading: false };
            }

        case RESET_REVIEWING_REPORT: {
            return { ...INIT_STATE };
        }
        default:
            return state;
    }
}

export default reportViewerReducer;
